import { useIntl } from "react-intl";

import { FeaturedInfoCard } from "@/components/adg4/featured-info-card/src/featured-info-card";
import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { useLocalizedImage } from "../../use-localized-image";

import { FeaturedImages, FeaturedInfoSection, TRACK } from "./featured-info";

const ChartIcon = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M4.39796e-06 17.2286L4.39796e-06 0.518066L3.42857 0.518066L3.42857 13.2552L9.46269 7.55626L12.8571 10.9507L18.1468 5.6613L15.0126 5.6613L15.0126 2.23274L24 2.23274V11.2201H20.5714V8.08538L12.8571 15.7994L9.39442 12.3367L3.42857 17.9711L3.42857 21.0894H24V24.518H4.39796e-06L4.39796e-06 17.2364C-1.46609e-06 17.2338 -1.46588e-06 17.2312 4.39796e-06 17.2286Z"
            fill="#1868DB"
        />
    </svg>
);

const PieChartIcon = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M10.8387 2.84065C4.85266 2.84065 0 7.6933 0 13.6794C0 19.6654 4.85266 24.5181 10.8387 24.5181C16.8248 24.5181 21.6774 19.6654 21.6774 13.6794H10.8387V2.84065Z"
            fill="#1868DB"
        />
        <path
            d="M24 10.5826C24 5.0241 19.494 0.518066 13.9355 0.518066V10.5826L24 10.5826Z"
            fill="#1868DB"
        />
    </svg>
);

const BidirectionalArrowsIcon = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M24 6.85316L17.6648 13.1884L15.3759 10.8995L17.8037 8.47163H0.670364V5.2346H17.8036L15.3759 2.80687L17.6648 0.517944L24 6.85316Z"
            fill="#1868DB"
        />
        <path
            d="M6.33525 24.518L0 18.1827L6.3353 11.8478L8.62417 14.1367L6.19649 16.5643H23.3297V19.8013H6.19645L8.62417 22.2291L6.33525 24.518Z"
            fill="#1868DB"
        />
    </svg>
);

const GroupIcon = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M6.41935 17.5502C6.41935 14.5572 8.84568 12.1308 11.8387 12.1308C14.8317 12.1308 17.2581 14.5572 17.2581 17.5502V24.5179H6.41935V17.5502Z"
            fill="#1868DB"
        />
        <path
            d="M16.4839 5.16311C16.4839 7.72856 14.4042 9.80827 11.8387 9.80827C9.27326 9.80827 7.19355 7.72856 7.19355 5.16311C7.19355 2.59765 9.27326 0.517944 11.8387 0.517944C14.4042 0.517944 16.4839 2.59765 16.4839 5.16311Z"
            fill="#1868DB"
        />
        <path
            d="M17.1124 9.71719C17.4097 9.77692 17.7173 9.80827 18.0323 9.80827C20.5977 9.80827 22.6774 7.72856 22.6774 5.16311C22.6774 2.59765 20.5977 0.517944 18.0323 0.517944C17.7173 0.517944 17.4097 0.549287 17.1124 0.609022C18.168 1.83032 18.8065 3.42215 18.8065 5.16311C18.8065 6.90406 18.168 8.49589 17.1124 9.71719Z"
            fill="#1868DB"
        />
        <path
            d="M6.56506 0.609022C5.50947 1.83032 4.87097 3.42215 4.87097 5.16311C4.87097 6.90406 5.50946 8.49589 6.56506 9.71719C6.26772 9.77692 5.9601 9.80827 5.64516 9.80827C3.07971 9.80827 1 7.72856 1 5.16311C1 2.59765 3.07971 0.517944 5.64516 0.517944C5.9601 0.517944 6.26772 0.549287 6.56506 0.609022Z"
            fill="#1868DB"
        />
        <path
            d="M6.30986 12.1308C4.94089 13.5273 4.09677 15.4402 4.09677 17.5502V24.5179H1V16.0018C1 13.8639 2.73309 12.1308 4.87097 12.1308H6.30986Z"
            fill="#1868DB"
        />
        <path
            d="M19.5806 24.5179V17.5502C19.5806 15.4402 18.7365 13.5273 17.3676 12.1308H18.8065C20.9443 12.1308 22.6774 13.8639 22.6774 16.0018V24.5179H19.5806Z"
            fill="#1868DB"
        />
    </svg>
);

export const TrackSection = () => {
    const intl = useIntl();
    const showGwp7999JiraFeaturesUpdates = checkFeatureFlagGate(
        featureFlags.gwp7999JiraFeatures
    );

    const trackProjectBoardsImage = useLocalizedImage(
        "trackProjectBoardsImage"
    );
    const trackTaskManagementImage = useLocalizedImage(
        "trackTaskManagementImage"
    );
    const trackDependencyManagementImage = useLocalizedImage(
        "trackDependencyManagementImage"
    );
    const trackGoalTrackingImage = useLocalizedImage("trackGoalTrackingImage");

    if (showGwp7999JiraFeaturesUpdates) {
        return (
            <FeaturedInfoSection
                variant={TRACK}
                eyebrow={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Label",
                    defaultMessage: "Track"
                })}
                header={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Header",
                    defaultMessage: "Stay on schedule"
                })}
                description={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Description",
                    defaultMessage:
                        "Get clarity on the status of every project - from cross-team initiatives down to the details of individual tasks."
                })}
            >
                <FeaturedInfoCard
                    image={{
                        image: {
                            src: FeaturedImages.trackTrackWorkWhereYouWork,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.TrackWork.Alt",
                                defaultMessage: "Jira and Gmail integration"
                            })
                        }
                    }}
                    Icon={ChartIcon}
                    title={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.TrackWork.Header",
                        defaultMessage: "Track work where you work"
                    })}
                    body={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.TrackWork.Description",
                        defaultMessage:
                            "Keep work up-to-date by tracking progress from your favorite tools like Slack, Figma and Gmail powered by an AI-assist"
                    })}
                />
                <FeaturedInfoCard
                    image={{
                        image: {
                            src: FeaturedImages.trackMonitorProgress,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.MonitorProgress.Alt",
                                defaultMessage: "Timeline view in Jira"
                            })
                        }
                    }}
                    Icon={PieChartIcon}
                    title={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.MonitorProgress.Header",
                        defaultMessage: "Monitor progress"
                    })}
                    body={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.MonitorProgress.Description",
                        defaultMessage:
                            "Stay up-to-date on the work's progress using the view you like: boards, lists, timeline, or calendars."
                    })}
                />
                <FeaturedInfoCard
                    image={{
                        image: {
                            src: FeaturedImages.trackRemoveManualWork,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.RemoveManualWork.Alt",
                                defaultMessage:
                                    "use Natural Language to create automations in Jira"
                            })
                        }
                    }}
                    Icon={BidirectionalArrowsIcon}
                    title={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.RemoveManualWork.Header",
                        defaultMessage: "Remove manual work"
                    })}
                    body={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.RemoveManualWork.Description",
                        defaultMessage:
                            "Use Rovo AI to create custom automations to keep your status up to date - from automated reminders to rules that move work forward."
                    })}
                />
                <FeaturedInfoCard
                    image={{
                        image: {
                            src: FeaturedImages.trackManageDependencies,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.ManageDependencies.Alt",
                                defaultMessage: "Map dependencies in Jira"
                            })
                        }
                    }}
                    Icon={GroupIcon}
                    title={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.ManageDependencies.Header",
                        defaultMessage: "Manage dependencies"
                    })}
                    body={intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.ManageDependencies.Description",
                        defaultMessage:
                            "Connect engineering, product, and marketing initiatives to coordinate big launches across every team."
                    })}
                />
            </FeaturedInfoSection>
        );
    }

    return (
        <FeaturedInfoSection
            variant={TRACK}
            eyebrow={intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Label",
                defaultMessage: "Track"
            })}
            header={intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Header",
                defaultMessage: "Manage the big picture down to every detail"
            })}
            description={intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Description",
                defaultMessage:
                    "Now that work is underway, use Jira to understand the major moving pieces and quickly drill down to the tiniest of details."
            })}
        >
            <FeaturedInfoCard
                image={{
                    image: {
                        src: trackProjectBoardsImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.ProjectBoards.ImageAlt",
                            defaultMessage: "Board view in Jira"
                        })
                    }
                }}
                Icon={ChartIcon}
                title={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.ProjectBoards.Header",
                    defaultMessage: "Project boards"
                })}
                body={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.ProjectBoards.Description",
                    defaultMessage:
                        "Track the status of everyone's tasks at each stage of the workflow. Understand how work is distributed across the team, what’s still in progress, and what to tackle next."
                })}
            />
            <FeaturedInfoCard
                image={{
                    image: {
                        src: trackTaskManagementImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.TaskManagement.ImageAlt",
                            defaultMessage: "Task details in Jira"
                        })
                    }
                }}
                Icon={PieChartIcon}
                title={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.TaskManagement.Header",
                    defaultMessage: "Task management"
                })}
                body={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.TaskManagement.Description",
                    defaultMessage:
                        "Tasks in Jira house the information you need to understand real-time work status, such as development activity and related issue progress. Integrate data from popular apps."
                })}
            />
            <FeaturedInfoCard
                image={{
                    image: {
                        src: trackDependencyManagementImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.DependencyManagement.ImageAlt",
                            defaultMessage:
                                "Timeline view in Jira with dependencies "
                        })
                    }
                }}
                Icon={BidirectionalArrowsIcon}
                title={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.DependencyManagement.Header",
                    defaultMessage: "Dependency management"
                })}
                body={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.DependencyManagement.Description",
                    defaultMessage:
                        "Jira shows you the order in which work needs to get done so you can spot bottlenecks before they become a blocker."
                })}
            />
            <FeaturedInfoCard
                image={{
                    image: {
                        src: trackGoalTrackingImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.GoalTracking.ImageAlt",
                            defaultMessage:
                                "Project goals in Summary view in Jira"
                        })
                    }
                }}
                Icon={GroupIcon}
                title={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.GoalTracking.Header",
                    defaultMessage: "Goal tracking"
                })}
                body={intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.GoalTracking.Description",
                    defaultMessage:
                        "Understand how work is mapping to company goals over time in the summary view. Easily share progress with stakeholders."
                })}
            />
        </FeaturedInfoSection>
    );
};
